import { render } from "./Overlay.vue?vue&type=template&id=7b303a9c"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=7b303a9c&lang=scss"
script.render = render

export default script